<template>
    <v-container fluid>
        <!--    Diálogo Persistente para mostrar Errores en Accesos    -->
        <v-dialog v-model="dialogErrors" persistent width="500">
            <v-card>
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <h3>{{errorsGuard}}</h3>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogErrors = false, errorsGuard = '', activar_camara = true, band_gafete = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente paraTest Salida    -->
        <v-dialog v-model="dialogTestTutorStudent" persistent width="500">
            <v-card>
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    {{errorsGuard}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogTestTutorStudent = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" scrollable persistent max-width="500px">
            <v-card :loading="loading" align="center" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('registrar_salidas')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <template v-slot:extension>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        fab
                                        color="green"
                                        bottom
                                        left
                                        absolute
                                        :loading="loading"
                                        @click="sendNotificationToTeachers(info_invitation)"
                                >
                                    <v-icon>mdi-bell-ring</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('send_notification_teachers')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="info_invitation.code_type === 0">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        color="red"
                                        bottom
                                        right
                                        absolute
                                        fab
                                        :loading="loading"
                                        @click="denyCheckOut(info_invitation.tutor.id, info_invitation.available_students)"
                                >
                                    <v-icon>mdi-account-cancel</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('denegar_salida')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="info_invitation.code_type === 1">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        color="red"
                                        bottom
                                        right
                                        absolute
                                        fab
                                        :loading="loading"
                                        @click="denyCheckOut(info_invitation.invitation.invited_tutor.id, info_invitation.available_students)"
                                >
                                    <v-icon>mdi-account-cancel</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('denegar_salida')}}</span>
                        </v-tooltip>
                    </template>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <br>
                        <v-layout v-if="info_invitation.code_type === 0 && info_invitation.tutor" justify-center class="text-xs-center" row wrap>
                            <v-flex class="text-xs-center edge pt-3 pb-3 pl-3 pr-3"  xs12>
                                <h3>Tutor</h3>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex xs11>
                                        <v-img
                                                :src="info_invitation.tutor.idFront"
                                                position="center center"
                                        ></v-img>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" xs12 v-if="info_invitation.available_students.length > 0">
                                <br>
                                <h3>{{$t('estudiante_s_no_recogido_s')}}</h3>
                                <br>
                                <v-list two-line>
                                    <v-list-item v-for="(student, i) in info_invitation.available_students" :key="i" :disabled="student.status === -1" :hidden="student.status === -1">
                                        <v-list-item-avatar>
                                            <v-img :src="student.avatar"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{student.first_name}} {{student.last_name}}</v-list-item-title>
                                            <v-list-item-title>{{student.classroom}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-flex>
                            <v-flex class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" xs12 v-if="info_invitation.picked_up_students.length > 0">
                                <br>
                                <h3>{{$t('estudiante_s_recogido_s')}}</h3>
                                <br>
                                <v-list two-line>
                                    <v-list-item v-for="(student2, i) in info_invitation.picked_up_students" :key="i" :disabled="student2.status === -1">
                                        <v-list-item-avatar>
                                            <v-img :src="student2.avatar"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{student2.first_name}} {{student2.last_name}}</v-list-item-title>
                                            <v-list-item-title>{{student2.classroom}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-flex>
                        </v-layout>
                        <v-layout v-else-if="info_invitation.code_type === 1 && info_invitation.invitation" justify-center class="text-xs-center" row wrap>
                            <v-flex class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" xs12>
                                <h3>{{$t('invitado')}}</h3>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex xs11>
                                        <v-img
                                                :src="info_invitation.invitation.invited_tutor.idFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" xs12 v-if="info_invitation.available_students.length > 0">
                                <br>
                                <h3>{{$t('estudiante_s_no_recogido_s')}}</h3>
                                <br>
                                <v-list two-line>
                                    <v-list-item v-for="(student, i) in info_invitation.available_students" :key="i" :disabled="student.status === -1" :hidden="student.status === -1">
                                        <v-list-item-avatar>
                                            <v-img :src="student.avatar"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{student.first_name}} {{student.last_name}}</v-list-item-title>
                                            <v-list-item-title>{{student.classroom}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-flex>
                            <v-flex class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" xs12 v-if="info_invitation.picked_up_students.length > 0">
                                <br>
                                <h3>{{$t('estudiante_s_recogido_s')}}</h3>
                                <br>
                                <v-list two-line>
                                    <v-list-item v-for="(student2, i) in info_invitation.picked_up_students" :key="i" :disabled="student2.status === -1">
                                        <v-list-item-avatar>
                                            <v-img :src="student2.avatar"></v-img>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{student2.first_name}} {{student2.last_name}}</v-list-item-title>
                                            <v-list-item-title>{{student2.classroom}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                    cols="12"
                    sm="6"
            >
                <v-card
                        width="750px"
                        class="mx-auto elevation-7"
                        align="center"
                        justify="center"
                >
                    <v-toolbar color="primary">
                        <v-toolbar-title>
                            {{$t('entradas_salidas')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h3>{{$t('mensaje_acercar_QR')}}</h3>
                        <v-flex>
                            <qrcode-stream v-if="activar_camara" @decode="onDecode" @init="onInit"/>
                            <p class="error">{{ error }}</p>
                        </v-flex>
                        <v-form
                                @submit.prevent="get_invitation_manual()">
                            <v-flex xs5>
                                <v-text-field
                                        v-model="a_qr_code"
                                        autofocus
                                        prepend-icon="mdi-qrcode"
                                        name="a_qr_code"
                                        :label="$t('qr_code')"
                                        :placeholder="$t('msg_qr_code')"
                                >
                                </v-text-field>
                                <v-btn
                                        color="primary"
                                        large
                                        type="submit"
                                >{{$t('enviar')}}
                                </v-btn>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import { QrcodeStream } from 'vue-qrcode-reader'
import store from '@/store'

export default {
  name: 'checkin_checkout',
  components: {
    QrcodeStream
  },
  data () {
    return {
      activar_camara: true,
      qr_code: '',
      error: '',
      valido: false,
      a_qr_code: '',
      salida: false,
      entrada: false,
      data_access: [],
      errorsGuard: '',
      head_color: '',
      info_invitation: [],
      dialog: false,
      comentarios_VE: '',
      dialogErrors: false,
      dialogInitial: false,
      guardHouse: 0,
      guardHouses: [],
      dialogTestTutorStudent: false,
      listaEstudiantesLocal: [],
      loading: false
    }
  },
  created () {
    if(localStorage.getItem('listaEstudiantes') !== null) {
      this.listaEstudiantesLocal = JSON.parse(localStorage.getItem('listaEstudiantes'))
    }
  },
  methods: {
    getCheckOutList () {
      let check_out_list_aux = []

      HTTP.get('checkout_list/' + localStorage.getItem('idGuardHouse') + '/',
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + localStorage.getItem('user-token')
          }
        })
        .then(response => {
          check_out_list_aux = response
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
      return check_out_list_aux
    },
    onDecode (result) {
      this.qr_code = result
      this.get_invitation()
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser'
        }
      }
    },
    get_invitation_manual () {
      console.log(this.a_qr_code)
      this.qr_code = this.a_qr_code
      HTTP.get('student/access_code/' + this.a_qr_code + '/' + localStorage.getItem('idGuardHouse'), {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.info_invitation = response.data
        // console.log('Tipo de Invitación:', this.info_invitation.code_type)
        var item = response.data
        var studentfiltered = this.deleteStudentNoAttendance(item.available_students)
        item.available_students = studentfiltered
        var fullItem = Object.assign(item, {"qrCode": this.qr_code})
        console.log('COMPLETOOOO = ', fullItem)
        if(item.available_students.length > 0) {
          this.addListItem(fullItem)
          // localStorage.setItem('listaEstudiantes',  JSON.stringify(this.listaEstudiantesLocal))
          // this.$socket.send(JSON.stringify( {
          //   "message": JSON.stringify(this.listaEstudiantesLocal)
          // }))
          this.dialog = true
          this.activar_camara = false
        } else {
          this.errorsGuard = this.$t('msg_students_already_picked_not_attend')
          this.head_color = 'red display-1 text--primary'
          this.dialogErrors = true
          this.activar_camara = false
        }
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.errorsGuard = this.$t('msg_qr_no_valido')
          this.head_color = 'red display-1 text--primary'
          this.dialogErrors = true
          this.activar_camara = false
        }
        if (error.response.status === 403) {
          this.errorsGuard = error.response.data.detail
          this.head_color = 'red display-1 text--primary'
          this.dialogErrors = true
          this.activar_camara = false
        }
      })
    },
    get_invitation () {
      if (this.qr_code !== '') {
        this.a_qr_code = this.qr_code
        HTTP.get('student/access_code/' + this.qr_code + '/' + localStorage.getItem('idGuardHouse'), {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(response => {
          this.info_invitation = response.data
          // console.log(this.info_invitation.students[0].avatar)
          var item = response.data
          var studentfiltered = this.deleteStudentNoAttendance(item.available_students)
          item.available_students = studentfiltered
          var fullItem = Object.assign(item, {"qrCode": this.qr_code})
          console.log(fullItem)
          if(item.available_students.length > 0) {
            this.addListItem(fullItem)
            // localStorage.setItem('listaEstudiantes',  JSON.stringify(this.listaEstudiantesLocal))
            // this.$socket.send(JSON.stringify( {
            //   "message": JSON.stringify(this.listaEstudiantesLocal)
            // }))
            this.dialog = true
            // this.qr_is_valid(this.info_invitation)
            this.activar_camara = false
          } else {
            this.errorsGuard = this.$t('msg_students_already_picked_not_attend')
            this.head_color = 'red display-1 text--primary'
            this.dialogErrors = true
            this.activar_camara = false
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.errorsGuard = this.$t('msg_qr_no_valido')
            this.head_color = 'red display-1 text--primary'
            this.dialogErrors = true
            this.activar_camara = false
          }
          if (error.response.status === 403) {
            this.errorsGuard = error.response.data.detail
            this.head_color = 'red display-1 text--primary'
            this.dialogErrors = true
            this.activar_camara = false
          }
        })
      }
    },
    denyCheckOut(uuidTutor, students) {
      this.loading = true
      for (let i = 0; i < students.length; i++) {
        HTTP.post('exit/invalidate/' + students[i].id, {
              idTutor: uuidTutor
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.language,
                'authorization': 'Token ' + store.getters.getToken
              }
            })
            .then(response => {
              // this.updateDataStudent(qrCode, uuidStudent)
              this.$socket.send(JSON.stringify( {
                "message":  JSON.stringify('addRecord')
              }))
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
              setTimeout(this.clear, 3000)
              console.log(response)
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.errorsGuard = this.$t('msg_student_exit_pass_disable')
                this.dialogErrors = true
              }
              console.log(error.response.data)
            })
      }
      this.loading = false
      this.dialog = false
      this.activar_camara = true
    },
    sendNotificationToTeachers (data) {
      this.loading = true
      for(let i = 0; i < data.available_students.length; i++) {
        if (data.available_students[i].status !== -1) {
          // Obtener el grado del estudiante
          const grade = data.available_students[i].grade
          let guardHouseName = localStorage.getItem('guardhouse_name')
          let band = false
          // Obtener el idGuardhouse del grado
          for (let j = 0; j < JSON.parse(localStorage.getItem('gradesGuardHouse')).length && band === false; j++) {
            if (JSON.parse(localStorage.getItem('gradesGuardHouse'))[j].grade === grade) {
              guardHouseName = JSON.parse(localStorage.getItem('gradesGuardHouse'))[j].guardHouseName
              band = true
            }
          }
          HTTP.post('student/' + data.available_students[i].id + '/exit/notification/',
            {
                guardhouse_name: guardHouseName
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.language,
                'authorization': 'Token ' + store.getters.getToken
              }
            })
          .then(ok => {
            console.log(ok)
          })
          .catch(error => {
            console.log(error)
          })
        }
        setTimeout(this.clearTime, 100)
      }
      this.loading = false
      this.dialog = false
      this.activar_camara = true
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', this.$t('teachers_were_notified'))
      setTimeout(this.clear, 3000)
    },
    getGuardhouseIds (data, gradeGuardhouseList) {
      // Obtener los grades de los estudiantes disponibles
      const studentGrades = new Set(
        data.available_students.map(student => student.grade)
      )

      // Filtrar los registros que coincidan por grade
      const guardhouseIds = gradeGuardhouseList
        .filter(item => studentGrades.has(item.grade))
        .map(item => item.idGuardhouse)

      // Eliminar duplicados
      return [...new Set(guardhouseIds)]
    },
    addListItem(item) {
      let band = false

      for(let i = 0 ; !band && i < this.listaEstudiantesLocal.length; i++) {
        console.log(this.listaEstudiantesLocal[i].qrCode, '===', item.qrCode)
        if(this.listaEstudiantesLocal[i].qrCode === item.qrCode){
          band = true
        }
      }
      if (!band) {
        this.listaEstudiantesLocal.push(item)
        console.log('agregando = ', item)
        let guardhouseIds = this.getGuardhouseIds(item, JSON.parse(localStorage.getItem('gradesGuardHouse')))
        console.log(guardhouseIds)
        // Agregar registro a la Base de Datos
        for (let i = 0; i < guardhouseIds.length; i++) {
          this.addQRCodeToDB(item.qrCode, guardhouseIds[i])
        }
        this.callWebsocket()
      }
      console.log(this.listaEstudiantesLocal)
    },
    deleteStudentNoAttendance(item) {
      let res = []
      console.log(item)
      for (let i=0; i < item.length; i++) {
        if(item[i].status !== -1) {
          console.log(item[i].status)
          res.push(item[i])
        }
      }
      return res
    },
    addQRCodeToDB (aQRCode, idGuardhouse) {
      HTTP.post('checkout_list/',
        {
          idSchool: localStorage.getItem('idSchool'),
          idGuardhouse: idGuardhouse,
          qr_code: aQRCode
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          console.log(ok)
        })
        .catch(error => {
          console.log(error)
        })
    },
    callWebsocket () {
      HTTP.post('send-notification/',
        {
          message: JSON.stringify('addRecord')
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          console.log(ok)
        })
        .catch(error => {
          console.log(error)
        })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    clearTime () {
      console.log('Time...')
    }
  }
}
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #439f46;
        color: white;
    }
    .wrapperw{
        width:300px;
        height:300px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #00A1E4;
    }
    .wrapperw img{
        position: relative;
        width:100%;
        height:auto;
    }
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
